import Input from "./Input";
import Todo from "./Todo";
import { StyledH2 } from "../styled/StyledH2";
import styled from "styled-components";
import { StyledLink } from "../styled/GlobalStyles";

import { useParams } from "react-router";
import { Link } from "react-router-dom";

import { useTodoAppContext } from "../providers/TodoAppContext"

//--------------------------------------------------------

const List = ({ list }) => {
  const { todos, addTodo } = useTodoAppContext()

  const { id } = useParams();

  if ((id) && (todos !== undefined)) {
    const paramList = todos.find(e => e.id === id)
    if (paramList) {
      return (
        
        <StyledListGroup>
            <StyledList>
              <StyledH2>{paramList.title}</StyledH2>

              <Input listId={paramList.id} todos={todos} addTodo={addTodo} />
              {
                paramList.tasks.map(e => (
                  <Todo
                    task={e}
                    key={e.idi}
                    list={paramList} />
                ))
              }
            </StyledList>
        </StyledListGroup>
      )
    } else { return <div>404 Liste nicht gefunden</div> }
  } else if (todos !== undefined) {
    return (
      <div>
      <StyledListGroup>
        <StyledList>
          <StyledLink to={`/list/${list.id}/`} ><StyledH2>{list.title}</StyledH2></StyledLink>

          <Input listId={list.id} todos={todos} addTodo={addTodo} />
          {
            list.tasks.map(e => (
              <Todo
                task={e}
                key={e.idi}
                list={list} />
            ))
          }
        </StyledList>
      </StyledListGroup>
      </div>
    )
  }
}

export default List;

// styled component --------------

const StyledList = styled.div`
justify-content: center;
padding: 0.75em;
margin: 0.5rem;
min-width: 21rem;
max-width: 30rem;
border-radius: 0.75rem;
box-shadow: ${({ theme }) => theme.shadow};
  -webkit-box-shadow: ${({ theme }) => theme.shadow};
  -moz-box-shadow: ${({ theme }) => theme.shadow}; 
margin: 1.0rem;
`


const StyledListGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 80px;
`
